import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ThemeService } from '../../theme.service';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, Subject, Subscription, takeUntil } from 'rxjs';
import { LoginUserModel } from '../../models/loginUserModel';
import { jwtDecode } from 'jwt-decode';
import { AvatarComponent } from '../avatar/avatar.component';
import { ProfileServicesService } from '../../services/profile-services.service';
import { RequestPhotoUpdate } from '../../models/requestPhotoUpdate';
import { DomSanitizer } from '@angular/platform-browser';

import { NavigationEnd, Router } from '@angular/router';
import { ProfileModel } from '../../models/ProfileModel';
import { DashboardServicesService } from '../../services/dashboard-services.service';
import { DataSharingService } from '../../data-sharing.service';
import { OutsideClickDirective } from '../../outside-click.directive';
import { FormsModule } from '@angular/forms';
import { NotificationCenterComponent } from "../notification-center/notification-center.component";
import { AppService } from '../../services/app.service';

@Component({
    selector: 'app-sidebar',
    imports: [CommonModule, AvatarComponent, OutsideClickDirective, NotificationCenterComponent],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit, OnDestroy {
  darkModeEnabled: boolean = false;
  private unsubscribe$ = new Subject();
  subMenuExpanded = -1;
  menuOptions: any[] = [];
  menuOptionsMob: any[] = [];
  tokenAuth = "";
  openMenu = false;
  data!: LoginUserModel;
  isImageLoaded = true;
  imageProfile: any = '';
  profileData!: ProfileModel;
  subscription!: Subscription;
  @ViewChild('chbxmode') modoObscuroChbox!: ElementRef;
  dashboardEditable!: boolean;
  _subscription: any;
  _subscriptionNotifcations: any;
  showNotications: boolean = false;
  collapse = false;
  moduleInvoiceActive: boolean = false;

  // null = loading, true = show, false = hide
  private validationSubject = new BehaviorSubject<boolean | null>(null);

  // Expose as an Observable for the template
  validationStatus$ = this.validationSubject.asObservable();

  constructor(private themeService: ThemeService, private service: ProfileServicesService, private sanitizer: DomSanitizer, private router: Router, private dashboardService: DashboardServicesService, private dataSharingService: DataSharingService, private appSrvc: AppService, private cdr: ChangeDetectorRef) {


    this.data = JSON.parse(localStorage.getItem('data')!)

    this.dataSharingService.dashboardEditable.subscribe(value => {
      this.dashboardEditable = value;
    });

    this.darkModeEnabled = localStorage.getItem('theme') == "dark" ? true : false;
    this._subscription = themeService.changeTheme.subscribe((value) => {
      this.darkModeEnabled = value;
    });

    this._subscriptionNotifcations = themeService.showNotification.subscribe((value) => {
      this.showNotications = value;
    });




  }

  hideLabels() {
    this.collapse = !this.collapse;
  }
  clickOutside(isOut: any) {

    if (isOut) {
      this.showSubMenu(-1);
    }
  }

  ngOnChangeDetection(): void {
    this.cdr.detectChanges();
  }

  onChanges(changes: SimpleChanges) {
    this.cdr.detectChanges();
  }
  ngOnInit(): void {

    this.dataSharingService.imageSource.subscribe(image => {
      if (image) {
        this.imageProfile = this.sanitizer.bypassSecurityTrustResourceUrl(image);
        this.isImageLoaded = true;
      }
    });

    this.cargaImagePerfil();
    this.cargaPerfil();
    this.menuOptions = [
      {
        icon: 'catalogos.png',
        label: 'Catálogos',
        route: '',
        isPrincipal: true,
        visible: this.data.UserType != 'Finance',
        subMenuExpanded: false,
        subMenu: [
          {
            label: 'Dispositivos',
            route: 'app/dispositivos',
            isPrincipal: false,
            visible: true,
            //route:'dispositvos'
          },
          {
            label: 'Dispositivos vinculados',
            route: 'app/dispositivos/vinculados',
            isPrincipal: false,
            visible: this.data.UserType == 'Administrator',
            //route:'dispositvos'
          },
          {
            label: 'Seguimiento a dispositivos',
            route: 'app/dispositivos/solicitudes',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Grupos de dispositivos',
            route: 'app/dispositivos/grupos',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Conductores',
            route: 'app/conductores',
            isPrincipal: false,
            visible: true,
          }
        ],
      },
      {
        icon: 'movimientos.png',
        label: 'Movimientos',
        route: '',
        isPrincipal: true,
        visible: this.data.UserType != 'Finance',
        subMenuExpanded: false,
        subMenu: [
          {
            label: 'Asignar conductores',
            route: 'app/conductores/asignacion',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Asignación de estaciones',
            route: 'app/estaciones/asignacion',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Generar código QR',
            route: 'app/generar_qr',
            isPrincipal: false,
            visible: this.data.UserType == 'Administrator' || this.data.UserType == 'Modify',
          }
        ],
      },
      {
        icon: 'facturacion.png',
        label: 'Facturación',
        route: 'app/facturacion',
        isPrincipal: true,
        visible: this.moduleInvoiceActive == true && this.data.PurchaseType != 'Credit',
        subMenuExpanded: false,
        subMenu: [


        ],
      },
      {
        icon: 'reportes.png',
        label: 'Reportes',
        route: '',
        isPrincipal: true,
        visible: true,
        subMenuExpanded: false,
        subMenu: [
          {
            label: 'Estado de cuenta',
            route: 'app/reportes/estado_cuenta',
            isPrincipal: false,
            visible: true,

          },
          {
            label: 'Consumos',
            route: 'app/reportes/consumos',
            isPrincipal: false,
            visible: true,
          },

          {
            label: 'Gráfica de consumos',
            route: 'app/reportes/grafica/consumos',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Balance',
            route: 'app/reportes/balance',
            isPrincipal: false,
            visible: this.data.CanGenerateBalanceReporte > 0,
          },
          {
            label: 'Facturas por comisión',
            route: 'app/reportes/facturas/comision',
            isPrincipal: false,
            visible: this.data.PurchaseType == 'Debit',
          },
          {
            label: 'Códigos generados',
            route: 'app/reportes/qrs_generados',
            isPrincipal: false,
            visible: true,
          }
        ],
      },
      {
        icon: 'pagos.png',
        label: 'Pagos',
        route: '',
        isPrincipal: true,
        visible: true,
        subMenuExpanded: false,
        subMenu: [
          {
            label: 'Agregar saldo',
            route: 'app/pagos/pago',
            isPrincipal: false,
            visible: this.data.PurchaseType != 'Credit' && this.data.UserType != 'Finance',
          },
          {
            label: 'Pagar facturas',
            route: 'app/pagos/pago',
            isPrincipal: false,
            visible: this.data.PurchaseType == 'Credit' && this.data.UserType != 'Finance',
          },
          {
            label: 'Pagos realizados',
            route: 'app/pagos',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Complementos de pago',
            route: 'app/pagos/complementos',
            isPrincipal: false,
            visible: this.data.PurchaseType == 'Credit',
          }


        ],
      },
      {
        icon: 'historial.png',
        label: 'Bitácora',
        route: 'app/bitacora',
        isPrincipal: true,
        visible: this.data.UserType != 'Finance',
        subMenuExpanded: false,
        subMenu: [


        ],
      },
      {
        icon: 'ayuda.png',
        label: 'Ayuda',
        route: '',
        isPrincipal: true,
        visible: this.data.UserType != 'Finance',
        subMenuExpanded: false,
        subMenu: [

          {
            label: 'Contacto',
            route: 'app/ayuda/contacto',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Tutoriales',
            route: 'app/ayuda/tutoriales',
            isPrincipal: false,
            visible: true,
          }
        ],
      },
      {
        icon: 'perfil.png',
        label: 'Perfil',
        route: '',
        isPrincipal: true,
        visible: this.data.UserType != 'Finance',
        subMenuExpanded: false,
        subMenu: [

          {
            label: 'Mi perfil',
            route: 'app/perfil',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Usuarios',
            route: 'app/usuarios',
            isPrincipal: false,
            visible: this.data.UserType != 'Finance',
          },
          {
            label: 'Personalizar tablero',
            route: 'app/dashboard',
            isPrincipal: false,
            visible: this.data.UserType != 'Finance',
          },
          {
            label: 'Cambiar contraseña',
            route: 'app/restaurar/acceso',
            isPrincipal: false,
            visible: this.data.UserType != 'Finance',
          },
          {
            label: 'Cerrar sesión',
            route: 'login',
            isPrincipal: false,
            visible: true,
          }

        ],
      }

    ];

    this.menuOptionsMob = [
      {
        icon: 'catalogos.png',
        label: 'Catálogos',
        route: '',
        isPrincipal: true,
        visible: this.data.UserType != 'Finance',
        subMenuExpanded: false,
        subMenu: [
          {
            label: 'Dispositivos',
            route: 'app/dispositivos',
            isPrincipal: false,
            visible: true,
            //route:'dispositvos'
          },
          {
            label: 'Dispositivos Enlazados',
            route: 'app/dispositivos/vinculados',
            isPrincipal: false,
            visible: this.data.UserType == 'Administrator',
            //route:'dispositvos'
          },
          {
            label: 'Seguimiento a dispositivos',
            route: 'app/dispositivos/solicitudes',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Grupos de dispositivos',
            route: 'app/dispositivos/grupos',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Conductores',
            route: 'app/conductores',
            isPrincipal: false,
            visible: true,
          }
        ],
      },
      {
        icon: 'movimientos.png',
        label: 'Movimientos',
        route: '',
        isPrincipal: true,
        visible: this.data.UserType != 'Finance',
        subMenuExpanded: false,
        subMenu: [
          {
            label: 'Asignar conductores',
            route: 'app/conductores/asignacion',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Asignación de estaciones',
            route: 'app/estaciones/asignacion',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Generar código QR',
            route: 'app/generar_qr',
            isPrincipal: false,
            visible: this.data.UserType == 'Administrator' || this.data.UserType == 'Modify',
          }
        ],
      },
      {
        icon: 'pagos.png',
        label: 'Facturación',
        route: 'app/facturacion',
        isPrincipal: true,
        visible: this.data.PurchaseType != 'Credit' && this.data.UserType != 'Finance' && this.moduleInvoiceActive,
        subMenuExpanded: false,
        subMenu: [


        ],
      },
      {
        icon: 'reportes.png',
        label: 'Reportes',
        route: '',
        isPrincipal: true,
        visible: true,
        subMenuExpanded: false,
        subMenu: [
          {
            label: 'Estado de cuenta',
            route: 'app/reportes/estado_cuenta',
            isPrincipal: false,
            visible: true,

          },
          {
            label: 'Consumos',
            route: 'app/reportes/consumos',
            isPrincipal: false,
            visible: true,
          },

          {
            label: 'Gráfica de consumos',
            route: 'app/reportes/grafica/consumos',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Balance',
            route: 'app/reportes/balance',
            isPrincipal: false,
            visible: this.data.CanGenerateBalanceReporte > 0,
          },
          {
            label: 'Códigos generados',
            route: 'app/reportes/qrs_generados',
            isPrincipal: false,
            visible: true,
          }
        ],
      },
      {
        icon: 'pagos.png',
        label: 'Pagos',
        route: '',
        isPrincipal: true,
        visible: true,
        subMenuExpanded: false,
        subMenu: [
          {
            label: 'Agregar saldo',
            route: 'app/pagos/pago',
            isPrincipal: false,
            visible: this.data.PurchaseType != 'Credit' && this.data.UserType != 'Finance',
          },
          {
            label: 'Pagar facturas',
            route: 'app/pagos/pago',
            isPrincipal: false,
            visible: this.data.PurchaseType == 'Credit' && this.data.UserType != 'Finance',
          },
          {
            label: 'Pagos realizados',
            route: 'app/pagos',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Complementos de pago',
            route: 'app/pagos/complementos',
            isPrincipal: false,
            visible: this.data.PurchaseType == 'Credit',
          }

        ],
      },
      {
        icon: 'historial.png',
        label: 'Bitácora',
        route: 'app/bitacora',
        isPrincipal: true,
        visible: this.data.UserType != 'Finance',
        subMenuExpanded: false,
        subMenu: [


        ],
      },
      {
        icon: 'ayuda.png',
        label: 'Ayuda',
        route: '',
        isPrincipal: true,
        visible: this.data.UserType != 'Finance',
        subMenuExpanded: false,
        subMenu: [

          {
            label: 'Contacto',
            route: 'app/ayuda/contacto',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Tutoriales',
            route: 'app/ayuda/tutoriales',
            isPrincipal: false,
            visible: true,
          }
        ],
      },
      {
        icon: 'perfil.png',
        label: 'Perfil',
        route: '',
        isPrincipal: true,
        visible: this.data.UserType != 'Finance',
        subMenuExpanded: false,
        subMenu: [

          {
            label: 'Mi perfil',
            route: 'app/perfil',
            isPrincipal: false,
            visible: true,
          },
          {
            label: 'Usuarios',
            route: 'app/usuarios',
            isPrincipal: false,
            visible: this.data.UserType != 'Finance',
          },
          {
            label: 'Personalizar tablero',
            route: 'app/dashboard',
            isPrincipal: false,
            visible: false,
          },
          {
            label: 'Cambiar contraseña',
            route: 'app/restaurar/acceso',
            isPrincipal: false,
            visible: this.data.UserType != 'Finance',
          },
          {
            label: 'Cerrar sesión',
            route: 'login',
            isPrincipal: false,
            visible: true,
          }

        ],
      }

    ];


    if (this.darkModeEnabled) {

    }

    this.checkStatusInvoice();
  }




  ngOnDestroy(): void {

    this.unsubscribe$.complete();
  }

  goTo(option: string, index: number, isMobile = false, toEdit: boolean = true) {

    if (option == 'login') {
      localStorage.removeItem('iaTime');
      localStorage.removeItem('tokenMovil');
      localStorage.removeItem('timeOut');
      localStorage.removeItem('data');
      sessionStorage.clear();
    }

    if (option == "app/dashboard") {

      if (toEdit) {
        this.dashboardService.setEditable(toEdit.toString())
        this.dataSharingService.dashboardEditable.next(toEdit);
      } else {
        this.dashboardService.setEditable(toEdit.toString())
        this.dataSharingService.dashboardEditable.next(toEdit);
      }


    }

    this.router.navigate([option]);

    this.subMenuExpanded = -1
    if (isMobile) {
      this.openMenu = false;
    }
  }

  getIconXiga() {
    return this.darkModeEnabled
      ? './assets/logos/logo_darkMode.png'
      : './assets/logos/logo_lightMode.png';
  }

  showSubMenu(index: number) {
    if (this.subMenuExpanded == index) {
      this.subMenuExpanded = -1;
    } else {

      this.subMenuExpanded = index;
    }
  }

  changeMode(): void {

    this.darkModeEnabled
      ? this.themeService.setLightTheme()
      : this.themeService.setDarkTheme();

  }


  getIconThemeMode() {
    return this.darkModeEnabled
      ? './assets/icons/dayMode.png'
      : './assets/icons/nightMode.png';
  }

  cargaImagePerfil() {
    this.isImageLoaded = false;
    this.service.loadUserImage(this.data.Client_number, this.data.User_id).subscribe({
      next: (resp: RequestPhotoUpdate) => {
        if (!resp.image) {
          this.imageProfile = '';
          this.isImageLoaded = true;
          return;
        }
        if (resp.isMongo) {
          this.service.loadImageMongo(resp.image).subscribe({
            next: (data: any) => {
              this.imageProfile = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
              this.isImageLoaded = true;
            },
            error: () => { this.isImageLoaded = true; }
          });
        } else {
          this.imageProfile = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + resp.image);
          this.isImageLoaded = true;
        }
      },
      error: () => { this.isImageLoaded = true; }
    })
  }

  checkStatusInvoice() {
    this.appSrvc.checkStatuInvoiceModule().subscribe({
      next: (resp: any) => {
        const index = this.menuOptions.findIndex(opt => opt.label === 'Facturación');
        const indexMobile = this.menuOptionsMob.findIndex(opt => opt.label == 'Facturación')
        if (index !== -1) {
          this.menuOptions[index] = {
            ...this.menuOptions[index],
            visible: resp.invoiceModuleActive && this.data.PurchaseType != 'Credit'
          };

          // ✅ Opcional: Clonar el array completo para asegurar la detección
          this.menuOptions = [...this.menuOptions];
        }
         if (indexMobile !== -1) {
          // ✅ Creamos una nueva referencia del objeto para forzar el render
          this.menuOptionsMob[indexMobile] = {
            ...this.menuOptionsMob[indexMobile],
            visible: resp.invoiceModuleActive && this.data.PurchaseType != 'Credit' && this.data.UserType != 'Finance'
          };

          // ✅ Opcional: Clonar el array completo para asegurar la detección
          this.menuOptions = [...this.menuOptions];

          this.menuOptionsMob = [...this.menuOptionsMob];
        }
      },
      error: (err: any) => {
        this.moduleInvoiceActive = false;
      }
      , complete: () => {
        this.cdr.markForCheck();
      }
    });
  }

  showPhoto() {

  }

  cargaPerfil() {
    this.service.loadProfile(this.data.Client_number, this.data.User_id).subscribe({
      next: (data: ProfileModel) => {
        this.profileData = data;

      },
      error: (err: any) => {

      }
    });


  }
}
